enum ProjectFolderType {
  Inbox = 1,
  Custom = 2
}

export default ProjectFolderType;
